export const GET_EXAM_ROOM_ASSIGNMENTS = "/exam-room-assignments";
export const ADD_NEW_EXAM_ROOM_ASSIGNMENT = "/exam-room-assignments";
export const UPDATE_EXAM_ROOM_ASSIGNMENT = "/exam-room-assignments";
export const DELETE_EXAM_ROOM_ASSIGNMENT = "/exam-room-assignments";





export const EXAM_ROOM_ASSIGNMENTS = "/exam-room-assignments";
//export const CHECK_AVAILABILITY    = ".exam-rooms/check-availability";